import "./App.css";
import WebsiteLoader from "./Component/Loader";
import { TransferSearchProvider } from "./Component/TransferSearchContext";
import Routing from "./Pages/Routing";

function App() {
  return (
    <>
    <TransferSearchProvider>
      <WebsiteLoader />
      <Routing />
    </TransferSearchProvider>
    </>
  );
}

export default App;
